import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { DropdownFilter, FloatInput, HeadPage } from "src/componentes";
import ProdutoCadastroCode from "./ProdutoCadastro.Code";
import { CategoriasCadastroDto } from "../../Categorias/Cadastro/CategoriasCadastro.Dto";
import { ConsultarCategoria } from "src/hook/Consulta/ConsultaCategoria.Module";
import { useEffect } from "react";
import { ProdutoCadastroProps } from "./ProdutoCadastro.Dto";

const ProdutoCadastroView = (props: ProdutoCadastroProps = {}) => {
  const code = ProdutoCadastroCode(props);
  const consultarCategoria = ConsultarCategoria();

  useEffect(() => {
    console.log(code.form.formState.errors);
  }, [code.form.formState.errors]);

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage
          headText={`${
            code.isDuplicate ? "Produto Duplicando" : "Produto Cadastro"
          }`}
          onBack={props.onCancel}
        >
          {code.menuItens !== undefined &&
            code.menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={code.handleClickNavigate(item.rota)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <FloatInput
                  label="Código"
                  errorsMessage={code.form.formState.errors.codigoProduto}
                  registerField={code.form.register("codigoProduto")}
                  inputMask="capitalizar"
                />
              </Col>
              <Col xs={12} sm={12} md={9} lg={9}>
                <FloatInput
                  label="Nome"
                  errorsMessage={code.form.formState.errors.nome}
                  registerField={code.form.register("nome")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <FloatInput
                  label="Descrição"
                  errorsMessage={code.form.formState.errors.descricao}
                  registerField={code.form.register("descricao")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Valor Unitário Comercial"
                  errorsMessage={
                    code.form.formState.errors.valorUnitarioComercial
                  }
                  registerField={code.form.register("valorUnitarioComercial")}
                  inputMask="double"
                />
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Unidade Comercial"
                  errorsMessage={code.form.formState.errors.unidadeComercial}
                  registerField={code.form.register("unidadeComercial")}
                  inputMask="maiusculas"
                />
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <FloatInput
                  label="Código NCM"
                  errorsMessage={code.form.formState.errors.codigoNCM}
                  registerField={code.form.register("codigoNCM")}
                  inputMask="int"
                  autoComplete
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <FloatInput
                  label="Código Barras"
                  errorsMessage={code.form.formState.errors.codigoBarras}
                  registerField={code.form.register("codigoBarras")}
                  inputMask="maiusculas"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <DropdownFilter<CategoriasCadastroDto>
                  fetchData={consultarCategoria.CategoriaBuscar}
                  loading={consultarCategoria.loading}
                  labelDescription="Categoria"
                  getDescription={(item: CategoriasCadastroDto) => item.nome}
                  getId={(item: CategoriasCadastroDto) => item.id}
                  registeredFields={{
                    id: code.form.register("categoriaId"),
                    description: code.form.register("categoriaNome"),
                  }}
                  errorsMessageDescription={
                    code.form.formState.errors.categoriaId
                  }
                  onSelect={(item: CategoriasCadastroDto | undefined) => {
                    if (item !== undefined) {
                      code.form.setValue("categoriaId", item.id);
                      code.form.setValue("categoriaNome", item.nome);
                    } else {
                      code.form.setValue("categoriaNome", "");
                    }
                  }}
                ></DropdownFilter>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default ProdutoCadastroView;
